import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

/**
 * Topbar global (v0.10.28 Fase B).
 * Diseño: marca G + título + tabs (Bandeja, Pendientes CRM, Nuevo, KPIs)
 * + cmdK search placeholder + avatar/usuario. Sticky top con borde inferior.
 */
export function Header() {
  const { sesion, cerrar, puedeAdministrar } = useAuth();
  const { pathname } = useLocation();

  const iniciales = (sesion?.sub ?? "U U")
    .split(/[.\s_-]/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join("");

  return (
    <header className="topbar">
      <Link to="/" className="topbar__brand">
        <div className="brand-mark">G</div>
        <div className="topbar__title">
          GEMA <span className="topbar__sub">· Backoffice PQRS</span>
        </div>
      </Link>

      {sesion && (
        <nav className="topbar__nav">
          <Link
            to="/"
            className={
              (pathname === "/" ||
                pathname.startsWith("/pqr/crm") ||
                pathname === "/expedientes")
                ? "is-active"
                : ""
            }
          >
            Bandeja
          </Link>
          <Link
            to="/expedientes/nuevo"
            className={pathname === "/expedientes/nuevo" ? "is-active" : ""}
          >
            Nuevo expediente
          </Link>
          <Link
            to="/kpis"
            className={pathname.startsWith("/kpis") ? "is-active" : ""}
          >
            KPIs
          </Link>
          {puedeAdministrar() && (
            <Link
              to="/usuarios"
              className={pathname.startsWith("/usuarios") ? "is-active" : ""}
            >
              Usuarios
            </Link>
          )}
          {puedeAdministrar() && (
            <Link
              to="/empresas"
              className={pathname.startsWith("/empresas") ? "is-active" : ""}
            >
              Empresas
            </Link>
          )}
        </nav>
      )}

      <div className="topbar__spacer" />

      {sesion && (
        <>
          <button
            type="button"
            className="cmdk"
            title="Búsqueda global (próximamente ⌘K)"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 16 16"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <circle cx="7" cy="7" r="4.5" />
              <path d="M10.5 10.5L13.5 13.5" />
            </svg>
            <span>Buscar radicado, NIC, cliente…</span>
            <span className="ml-auto flex gap-1">
              <span className="kbd">⌘</span>
              <span className="kbd">K</span>
            </span>
          </button>

          <div className="topbar__user">
            <div className="avatar">{iniciales || "U"}</div>
            <div>
              {sesion.sub} <span className="muted">· {sesion.rol}</span>
            </div>
            <button
              onClick={cerrar}
              className="btn--ghost"
              style={{ marginLeft: 6, height: 28, padding: "0 10px", fontSize: 12 }}
              title="Cerrar sesión"
            >
              ⏏
            </button>
          </div>
        </>
      )}
    </header>
  );
}
